import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import {
  Button,
  Divider,
  Form,
  Input,
  Dropdown,
  Icon,
  Tab,
  Menu,
  Label
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import {
  getUtms,
  updateUtm,
  updateFieldUtm,
  deleteUtms
} from '../../services/AdServiceManager';
import UtmAccountsSelectionModal from './UtmAccountsSelectionModal';
import * as AppActions from '../../actions';

const Container = styled.div`
  max-width: 100%;
`;
const Title = styled.h1`
  margin-bottom: 20px;
  color: #111;
`;
const ButtonContainer = styled.div`
  align-items: flex-end;
  display: flex;
`;
const EditRow = styled.div`
  margin-bottom: 30px;
`;
const ItemList = styled.div`
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #ddd;
`;
const Validations = styled.div`
  margin-left: 20px !important;
`;
const ValidationText = styled.label`
  margin-right: 5px !important;
  text-transform: uppercase !important;
  font-weight: bold;
  font-size: 10px;
  color: #21ba45;
`;
const LabelIf = styled.label`
  width: 195px !important;
  text-align: right;
`;

class UtmManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idUpdate: null,
      utms: [],
      actives: [],
      archives: [],
      conditionals: [],
      edit: false,
      loading: false,
      activeIndex: 0,
      showUtmAccountsModal: false,
      currentUtmAccounts: [],
      currentUtmIndex: 0
    };

    this.options = [
      { key: 'Year', value: 'Year', text: 'YEAR' },
      { key: 'Month', value: 'Month', text: 'MONTH' },
      { key: 'Client', value: 'Client', text: 'CLIENT' },
      { key: 'Campaign', value: 'Campaign', text: 'CAMPAIGN' },
      { key: 'Audience', value: 'Audience', text: 'AUDIENCE' },
      { key: 'Placements', value: 'Placements', text: 'PLACEMENTS' },
      { key: 'Ad Type', value: 'Ad Type', text: 'AD TYPE' },
      { key: 'Ad Name', value: 'Ad Name', text: 'AD NAME' }
    ];

    this.optionsOperator = [
      { key: 'AND', value: 'AND', text: 'AND' },
      { key: 'OR', value: 'OR', text: 'OR' }
    ];
  }

  componentDidMount() {
    const { setSectionTitle } = this.props;
    if (setSectionTitle) setSectionTitle('UTM Manager');
    this._getUtms();
  }

  toggleEdit = () => {
    this.setState({ edit: !this.state.edit }, () => {
      if (!this.state.edit) {
        const _actives = Object.assign(this.state.actives);
        const _archives = Object.assign(this.state.archives);

        const actives = _actives.filter(
          (ac) => !ac.new && ac.status === 'active'
        );
        const archives = _archives.filter(
          (ar) => !ar.new && ar.status === 'archive'
        );

        this.setState({ actives, archives });
      }
    });
  };

  onChangeRule = (indexUtm, indexRule, value, field) => {
    const utms =
      this.state.activeIndex === 0 ? this.state.actives : this.state.archives;
    const key = this.state.activeIndex === 0 ? 'actives' : 'archives';
    utms[indexUtm].rules[indexRule][field] = value;

    this.setState({ [key]: utms });
  };

  onChangeUtm = (index, value, field) => {
    const utms =
      this.state.activeIndex === 0 ? this.state.actives : this.state.archives;
    const key = this.state.activeIndex === 0 ? 'actives' : 'archives';
    utms[index][field] = value;

    this.setState({ [key]: utms });
  };

  _getUtms = async () => {
    const response = await getUtms();
    const conditionals = response.data.conditionals.map(
      ({ id, conditional }) => ({
        key: id,
        value: id,
        text: conditional.toUpperCase()
      })
    );
    const _utms = response.data.utms.map(async (utm, i) => {
      if (!utm.position)
        await updateFieldUtm({
          id: utm.id,
          field: { column: 'position', value: i },
          type: 'updateField'
        });

      return { ...utm, position: i };
    });

    Promise.all(_utms).then((utms) => {
      const actives = utms.filter((f) => f.status === 'active');
      const archives = utms.filter((f) => f.status === 'archive');
      this.setState({ utms, conditionals, actives, archives });
    });
  };

  handleTabChange = (e, data) => {
    this.setState({ activeIndex: data.activeIndex });
  };

  hasEmptyFields = (index) => {
    let isEmpty = false;
    const utms =
      this.state.activeIndex === 0 ? this.state.actives : this.state.archives;
    const utm = utms[index];

    if (utm.name.length === 0 || utm.code.length === 0) isEmpty = true;

    utm.rules.forEach((rule, j) => {
      const validOperator = j === 0 ? false : rule.operator.length === 0;
      if (!rule.condition_id || rule.value.length === 0 || validOperator)
        isEmpty = true;
    });

    return isEmpty;
  };

  downUtm = async (index) => {
    const utms =
      this.state.activeIndex === 0 ? this.state.actives : this.state.archives;
    const utm = utms[index];
    const nextUtm = utms[index + 1];

    await updateFieldUtm({
      id: utm.id,
      field: { column: 'position', value: index + 1 },
      type: 'updateField'
    });
    await updateFieldUtm({
      id: nextUtm.id,
      field: { column: 'position', value: index },
      type: 'updateField'
    });
    this._getUtms();
  };

  upUtm = async (index) => {
    const utms =
      this.state.activeIndex === 0 ? this.state.actives : this.state.archives;
    const utm = utms[index];
    const prevUtm = utms[index - 1];

    await updateFieldUtm({
      id: utm.id,
      field: { column: 'position', value: index - 1 },
      type: 'updateField'
    });
    await updateFieldUtm({
      id: prevUtm.id,
      field: { column: 'position', value: index },
      type: 'updateField'
    });
    this._getUtms();
  };

  saveUtm = async (index) => {
    if (!this.hasEmptyFields(index)) {
      const { activeIndex, actives, archives } = this.state;
      const utms = activeIndex === 0 ? actives : archives;
      const key = activeIndex === 0 ? 'actives' : 'archives';

      this.setState({ idUpdate: index, loading: true }, async () => {
        const utm = utms[index];
        const _rules = utm.rules.map((rule) => {
          const operator = rule.operator === '' ? 'AND' : rule.operator;
          return { ...rule, operator };
        });

        utm.rules = _rules;
        const response = await updateUtm(utm);
        if (response.data.utm) {
          utms[index] = response.data.utm;
          this.setState({ idUpdate: null, loading: false, [key]: utms }, () => {
            this._getUtms();
            toast.success('UTMs updated.', {
              position: 'top-center',
              autoClose: 3500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false
            });
          });
        } else {
          toast.error('Something went wrong will updating UTMs.', {
            position: 'top-center',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
          });
        }
      });
    } else {
      toast.warn('Make sure to fill all required fields.', {
        position: 'top-center',
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false
      });
      this.setState({ error: true }, () => {
        setTimeout(() => {
          this.setState({ error: false });
        }, 2000);
      });
    }
  };

  duplicateUtm = async (index) => {
    const { activeIndex, actives, archives } = this.state;
    const utm = actives[index];

    const utms = activeIndex === 0 ? actives : archives;
    const key = activeIndex === 0 ? 'actives' : 'archives';

    const { code, name, rules, accounts } = utm || {};

    const newUtm = {
      code: code || '',
      name: `${name} - copy` || '',
      id: false,
      new: true,
      position: 0,
      status: activeIndex === 0 ? 'active' : 'archive',
      rules: rules || [],
      accounts: accounts || []
    };

    utms.unshift(newUtm);

    this.setState(
      (prevState) => ({
        ...prevState,
        [key]: utms,
        edit: true
      }),
      () => {
        this.saveUtm(0);
        toast.success('UTM duplicated', {
          position: 'top-center',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false
        });
      }
    );
  };

  // to do: create delete confirmation
  deleteUtm = async (index) => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const key = activeIndex === 0 ? 'actives' : 'archives';
    const utm = utms[index];
    if (utm.id) {
      const response = await deleteUtms({ id: utm.id, type: 'utm' });
      const { data } = response;
      const { utms: responseUtms } = data || {};
      const newActives = responseUtms
        ? responseUtms.filter((f) => f.status === 'active')
        : actives;
      const newArchives = responseUtms
        ? responseUtms.filter((f) => f.status === 'archive')
        : archives;
      this.setState((prevState) => ({
        ...prevState,
        idUpdate: null,
        loading: false,
        actives: newActives,
        archives: newArchives
      }));
    } else {
      utms.splice(index, 1);
      this.setState((prevState) => ({ ...prevState, [key]: utms }));
    }
    toast.error('UTM deleted.', {
      position: 'top-center',
      autoClose: 3500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    });
  };

  deleteRule = async (indexUtm, indexRule) => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const key = activeIndex === 0 ? 'actives' : 'archives';
    const rule = utms[indexUtm].rules[indexRule];

    if (rule.id) {
      const response = await deleteUtms({ id: rule.id, type: 'rule' });
      const { data } = response;
      const { utms: responseUtms } = data || {};
      const newActives = responseUtms
        ? responseUtms.filter((f) => f.status === 'active')
        : actives;
      const newArchives = responseUtms
        ? responseUtms.filter((f) => f.status === 'archive')
        : archives;
      this.setState({
        idUpdate: null,
        loading: false,
        actives: newActives,
        archives: newArchives
      });
    } else {
      utms[indexUtm].rules.splice(indexRule, 1);

      this.setState((prevState) => ({ ...prevState, [key]: utms }));
    }
  };

  changeStatus = async (index) => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const utm = utms[index];
    const { status: utmStatus, id: utmId } = utm;
    const status = utmStatus === 'active' ? 'archive' : 'active';

    await updateFieldUtm({
      id: utmId,
      field: { column: 'status', value: status },
      type: 'updateField'
    });
    this._getUtms();
    toast.success('UTM Status changed.', {
      position: 'top-center',
      autoClose: 3500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    });
  };

  newRule = (index) => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const key = activeIndex === 0 ? 'actives' : 'archives';

    utms[index].rules.push({
      condition: '',
      condition_id: null,
      field: '',
      id: false,
      operator: 'AND',
      value: ''
    });

    this.setState((prevState) => ({ ...prevState, [key]: utms }));
  };

  newUtm = () => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const key = activeIndex === 0 ? 'actives' : 'archives';

    const utm = {
      code: '',
      name: '',
      id: false,
      new: true,
      position: 0,
      status: activeIndex === 0 ? 'active' : 'archive',
      rules: [],
      accounts: []
    };

    utms.unshift(utm);

    this.setState((prevState) => ({
      ...prevState,
      [key]: utms,
      edit: true
    }));
  };

  renderContent = (utm, i, listLength) => {
    if (!this.state.edit) {
      return (
        <ItemList>
          <Form.Group widths="equal">
            <Icon
              name="arrow circle down"
              size="large"
              link
              style={{
                visibility: i === listLength - 1 ? 'hidden' : 'visible'
              }}
              onClick={() => this.downUtm(i)}
            />
            <Icon
              name="arrow circle up"
              size="large"
              link
              style={{ visibility: i === 0 ? 'hidden' : 'visible' }}
              onClick={() => this.upUtm(i)}
            />
            <Form.Input
              fluid
              label={utm.name ? utm.name : 'New utm'}
              value={utm.code}
              onChange={(ev, data) => this.onChangeUtm(i, data.value, 'code')}
              disabled
              placeholder="Enter code"
            />
          </Form.Group>
          {utm.rules.map((rule, j) => {
            const ruleKey = `rule_${i}_${j}`;
            return (
              <Form.Field key={ruleKey} inline>
                <Validations>
                  <ValidationText>- If</ValidationText>
                  <ValidationText>{rule.field}</ValidationText>
                  <ValidationText>{rule.condition}</ValidationText>
                  <ValidationText>{rule.value}</ValidationText>
                </Validations>
              </Form.Field>
            );
          })}
          {this.renderUtmAccountsElements(i)}
        </ItemList>
      );
    }

    return (
      <EditRow>
        <Form.Group widths="equal">
          <Form.Input
            label=""
            value={utm.name}
            onChange={(_, data) => this.onChangeUtm(i, data.value, 'name')}
            placeholder="Enter name"
            error={this.state.error && utm.name.length === 0}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            fluid
            label=""
            value={utm.code}
            onChange={(_, data) => this.onChangeUtm(i, data.value, 'code')}
            placeholder="Enter code"
            error={this.state.error && utm.code.length === 0}
          />
        </Form.Group>

        {utm.rules.map((rule, j) => {
          const ruleKey = `rule_${i}_${j}`;
          return (
            <Form.Group key={ruleKey} inline className="ad-utm-form-group">
              {j === 0 ? (
                <Form.Field inline>
                  <LabelIf>If</LabelIf>
                </Form.Field>
              ) : (
                <Form.Field inline>
                  <Dropdown
                    options={this.optionsOperator}
                    placeholder="Select operator"
                    onChange={(ev, data) =>
                      this.onChangeRule(i, j, data.value, 'operator')
                    }
                    value={rule.operator}
                    clearable
                    selection
                    error={this.state.error && rule.operator.length === 0}
                  />
                </Form.Field>
              )}
              <Form.Field inline>
                <Dropdown
                  options={this.options}
                  placeholder="Select field"
                  onChange={(_, data) =>
                    this.onChangeRule(i, j, data.value, 'field')
                  }
                  value={rule.field}
                  clearable
                  selection
                  error={this.state.error && rule.field.length === 0}
                />
              </Form.Field>
              <Form.Field inline>
                <Dropdown
                  options={this.state.conditionals}
                  placeholder="Select condition"
                  onChange={(_, data) =>
                    this.onChangeRule(i, j, data.value, 'condition_id')
                  }
                  value={rule.condition_id}
                  clearable
                  selection
                  error={this.state.error && !rule.condition_id}
                />
              </Form.Field>
              <Form.Field inline>
                <Input
                  placeholder="Enter value"
                  onChange={(ev, data) =>
                    this.onChangeRule(i, j, data.value, 'value')
                  }
                  value={rule.value}
                />
              </Form.Field>
              <Form.Field inline>
                <Button icon onClick={() => this.deleteRule(i, j)} color="red">
                  <Icon name="trash" />
                </Button>
              </Form.Field>
            </Form.Group>
          );
        })}

        <Form.Group widths="equal">
          <ButtonContainer className="field">
            <Button
              icon
              onClick={() => this.saveUtm(i)}
              color="blue"
              loading={this.state.loading && this.state.idUpdate === i}
            >
              Update
            </Button>
            <Button icon onClick={() => this.newRule(i)} color="green">
              New Rule
            </Button>
            <Button icon onClick={() => this.deleteUtm(i)} color="red">
              Delete UTM
            </Button>
            <Button icon onClick={() => this.duplicateUtm(i)} color="grey">
              Duplicate UTM
            </Button>
            <Button icon onClick={() => this.changeStatus(i)} color="grey">
              {utm.status === 'active' ? 'Archive' : 'Active'}
            </Button>
          </ButtonContainer>
        </Form.Group>
        <Divider hidden />
        {this.renderUtmAccountsElements(i, true)}
      </EditRow>
    );
  };

  renderUtmAccountsElements = (utmRuleIndex, inEditMode) => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const utm = utms[utmRuleIndex];
    const { accounts } = utm || {};
    let textContent = 'All Accounts';
    if (accounts && accounts.length > 0) {
      const adAccountNames = accounts.map((account) => account.accountName);
      textContent = adAccountNames.join(',');
    }
    return (
      <Label>
        <span>{`Applies to: ${textContent} `} </span>
        {inEditMode ? (
          <span style={{ cursor: 'pointer' }}>
            {'('}
            <a
              role="button"
              tabIndex={0}
              onClick={() =>
                this.toggleUtmAccountsModal(utmRuleIndex, accounts)
              }
            >
              Edit
            </a>
            {')'}
          </span>
        ) : null}
      </Label>
    );
  };

  toggleUtmAccountsModal = (utmRuleIndex, currentUtmAccounts) => {
    const { showUtmAccountsModal } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      showUtmAccountsModal: !showUtmAccountsModal,
      currentUtmAccounts: currentUtmAccounts || [],
      currentUtmIndex: utmRuleIndex
    }));
  };

  updateUtmsAccountsState = (utmRuleIndex, selectedAccounts) => {
    const { activeIndex, actives, archives } = this.state;
    const utms = activeIndex === 0 ? actives : archives;
    const newUtms = [...utms];
    newUtms[utmRuleIndex].accounts = selectedAccounts;

    if (activeIndex === 0) {
      this.setState((prevState) => ({
        ...prevState,
        showUtmAccountsModal: false,
        currentUtmAccounts: [],
        actives: utms
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        showUtmAccountsModal: false,
        currentUtmAccounts: [],
        archives: utms
      }));
    }
    toast.info('Be sure to update the UTM before finishing.', {
      position: 'top-right',
      autoClose: 3500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    });
  };

  renderTab = (utms) => {
    return (
      <Form className="ad-utm-form">
        {utms.map((utm, i) => {
          const utmKey = `utm_${i}`;
          return (
            <div key={utmKey}>{this.renderContent(utm, i, utms.length)}</div>
          );
        })}
      </Form>
    );
  };

  renderTabs = () => {
    const tabs = [
      {
        menuItem: <Menu.Item>Active</Menu.Item>,
        pane: (
          <Tab.Pane defaultActiveIndex={this.state.activeIndex}>
            {this.renderTab(this.state.actives)}
          </Tab.Pane>
        )
      },
      {
        menuItem: <Menu.Item>Archive</Menu.Item>,
        pane: (
          <Tab.Pane defaultActiveIndex={this.state.activeIndex}>
            {this.renderTab(this.state.archives)}
          </Tab.Pane>
        )
      }
    ];

    return (
      <Tab
        renderActiveOnly={false}
        defaultActiveIndex={this.state.activeIndex}
        panes={tabs}
        onTabChange={this.handleTabChange}
      />
    );
  };

  render() {
    const {
      showUtmAccountsModal,
      currentUtmAccounts,
      currentUtmIndex
    } = this.state;
    return (
      <Container className="container ad-import-container">
        <Title>UTM Manager</Title>
        <ButtonContainer className="field">
          <Button color="blue" onClick={() => this.toggleEdit()}>
            {this.state.edit ? 'Save' : 'Edit'}
          </Button>
          <Button color="green" onClick={() => this.newUtm()}>
            New
          </Button>
        </ButtonContainer>
        <Divider hidden />
        {this.renderTabs()}
        <UtmAccountsSelectionModal
          showUtmAccountsModal={showUtmAccountsModal}
          toggleUtmAccountsModal={this.toggleUtmAccountsModal}
          initialUtmAccounts={currentUtmAccounts}
          updateUtmsParentState={this.updateUtmsAccountsState}
          currentUtmIndex={currentUtmIndex}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  adImport: state.adImport
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UtmManager);



// WEBPACK FOOTER //
// ./src/screens/Utm/UtmManager.js